import React from "react";
import { cn } from "@/lib/utils";

const LABELS = { critical: "Changes meaning", high: "May change meaning", medium: "Minor" };

// LangCraft functional-load priority for a mispronounced sound.
const PriorityBadge = ({ priority, className }) => (
  <span
    className={cn(
      "inline-flex shrink-0 items-center whitespace-nowrap rounded-sm border px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-wider",
      priority === "critical"
        ? "border-danger/50 bg-danger/10 text-danger"
        : "border-accent/50 bg-accent/10 text-accent",
      className
    )}
  >
    {LABELS[priority] || "Changes meaning"}
  </span>
);

export default PriorityBadge;
